<template>
  <h3 class="settings-title">{{ title }}</h3>
  
</template>

<script>
export default {
    props: ['title']
}
</script>

<style>

</style>